import { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BADGE = { finance:"Finance Ops", legal:"Legal Ops", both:"Both" };
const BADGE_COLOR = { finance:"text-emerald-400 bg-emerald-400/10 border-emerald-400/20", legal:"text-blue-400 bg-blue-400/10 border-blue-400/20", both:"text-[#00FF66] bg-[#00FF66]/10 border-[#00FF66]/20" };

export default function AdminPage({ onBack }) {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/applications`).then((r) => setApplications(r.data)).finally(() => setLoading(false));
  }, []);

  const total = applications.length;
  const both  = applications.filter((a) => a.service_type === "both").length;
  const single = applications.filter((a) => a.service_type !== "both").length;

  return (
    <div className="admin-wrap" data-testid="admin-page">
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between py-6 mb-8 border-b border-white/10">
          <div>
            <button onClick={onBack} className="text-[#00FF66] text-sm mb-3 hover:opacity-70 transition-opacity" data-testid="admin-back-btn">
              ← Back to site
            </button>
            <h1 className="text-2xl font-bold text-white">Application Dashboard</h1>
            <p className="text-gray-500 text-sm mt-1">X Analyst operator applications</p>
          </div>
          <span className="text-gray-600 text-sm">{new Date().toLocaleDateString("en-US",{year:"numeric",month:"long",day:"numeric"})}</span>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mb-8">
          {[["Total Applications",total],["Finance + Legal (Both)",both],["Single Function",single]].map(([label,val],i)=>(
            <div key={i} className="bg-[#111111] border border-white/10 rounded-2xl p-6" data-testid={`admin-stat-${i}`}>
              <div className="text-3xl font-bold text-[#00FF66] mb-1">{val}</div>
              <div className="text-gray-400 text-sm">{label}</div>
            </div>
          ))}
        </div>

        {/* Table */}
        <div className="bg-[#111111] border border-white/10 rounded-2xl overflow-hidden">
          {loading ? (
            <div className="p-16 text-center text-gray-500">Loading applications...</div>
          ) : applications.length === 0 ? (
            <div className="p-16 text-center text-gray-500" data-testid="admin-empty">
              No applications yet. Share your landing page to start collecting leads.
            </div>
          ) : (
            <table className="admin-table" data-testid="admin-table">
              <thead>
                <tr>
                  <th>Firm</th><th>Contact</th><th>Email</th><th>AUM</th><th>Service</th><th>Software</th><th>Applied</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((app) => (
                  <tr key={app.id} data-testid={`admin-row-${app.id}`}>
                    <td className="text-white font-medium">{app.firm_name}</td>
                    <td>{app.contact_name}</td>
                    <td><a href={`mailto:${app.email}`} className="text-[#00FF66] hover:underline">{app.email}</a></td>
                    <td>{app.aum_range}</td>
                    <td>
                      <span className={`text-xs px-2 py-1 rounded-full border ${BADGE_COLOR[app.service_type] || BADGE_COLOR.legal}`}>
                        {BADGE[app.service_type] || app.service_type}
                      </span>
                    </td>
                    <td className="text-gray-500">{app.software_stack?.join(", ") || "—"}</td>
                    <td className="text-gray-600 text-xs">
                      {new Date(app.created_at).toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"})}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
